// extracted by mini-css-extract-plugin
export var errorIcon = "_m6-1";
export var nameLogo = "_m6-0";